import { AutoComplete, AutoCompleteCompleteMethodParams, AutoCompleteProps } from 'primereact/autocomplete';
import { DropdownChangeParams } from 'primereact/dropdown';
import { SelectItem } from 'primereact/selectitem';
import { useState } from 'react';

export interface DropdownLikeAutoCompleteProps extends Omit<AutoCompleteProps, 'onChange'> {
  options?: SelectItem[];
  onChange?(event: DropdownChangeParams): void;
}

export default function DropdownLikeAutoComplete(props: DropdownLikeAutoCompleteProps) {
  const { options, onChange, value, ...autoCompleteProps } = props;
  const [suggestions, setSuggestions] = useState([...options]);
  const [internalValue, setInternalValue] = useState<any>('');

  const autocompleteValue = options.find((option) => option.value === value);

  const searchOptions = (event: AutoCompleteCompleteMethodParams) => {
    const filtered = [];
    const query = event.query;
    for (const option of options) {
      if (option.label.toLowerCase().includes(query.toLowerCase())) {
        filtered.push(option);
      }
    }
    setSuggestions(filtered);
  };

  return (
    <AutoComplete
      {...autoCompleteProps}
      suggestions={suggestions}
      field="label"
      value={autocompleteValue ?? internalValue}
      dropdown
      completeMethod={searchOptions}
      onChange={async (e) => {
        setInternalValue(e.value);
        if (e.value?.value) {
          await onChange({ ...e, value: e.value.value, target: { ...e.target, value: e.value.value } });
        } else {
          await onChange({ ...e, value: null, target: { ...e.target, value: null } });
        }
      }}
    />
  );
}
